<template>
  <div
    class="position-relative"
    v-if="block.isShowed('cover')"
  >
    <app-video-embed
      :src="project.video_url"
      v-if="project.video_url"
    >
      <template #placeholder>
        <figure class="cover">
          <img
            :src="cover"
            :alt="project.name"
            class="image"
          >
        </figure>
      </template>
    </app-video-embed>

    <figure
      class="cover"
      v-else
    >
      <img
        :src="cover"
        :alt="project.name"
        class="image"
      >
    </figure>

    <router-link
      class="btn"
      :to="{ name: 'PrivateSettingsGeneral', params: { projectSlug: project.slug } }"
      v-if="project.isAuthorized(authUser)"
    >
      <fa-icon
        class="margin__r--6"
        :icon="['fal', 'camera']"
      />

      {{ t('literal.edit_cover') }}
    </router-link>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from '@/vendors/i18n'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { getImagePath } from '@/utils/utils'
import { get as _get } from 'lodash'

const AppVideoEmbed = defineAsyncComponent(() => import('&/atoms/AppVideoEmbed'))

defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { t } = useI18n()
const { authUser } = storeToRefs(useAuthenticationStore())

const objects = inject('objects', {})

const project = computed(() => _get(objects.value, 'project'))
const cover = computed(() => _get(project.value, 'image.medium.url') || _get(project.value, 'campaign.image.medium.url') || getImagePath('placeholders/project-card-cover.jpg'))
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  background-size: 100% auto;

  @include aspect-ratio(3, 2);
}

.image {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
}

.btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: $white;
  padding: 3px 12px;
  font-size: em(14px);
  color: $dg;
  box-shadow:  0 4px 8px 0 rgba(82, 97, 115, 0.3);

  @include mq(md) {
    opacity: .4;
  }

  &:hover {
    background: $white;
    opacity: 1;
  }
}
</style>